import { useState, useEffect } from 'react';
import { useDynamo } from '../util/api';
import { validatePhoneNumber } from '../util/aux';


export const useWidget = (initialValue) => {
    const [state, setState] = useState(initialValue || {}); 
    const { getDynamo, saveDynamo, loading, error, record } = useDynamo(state);

    // Write to dynamo on each page change
    useEffect(() => {
        const runEffect = async () => {
            if (state.phone) {
                if (state.pageNumber) {
                    // console.log("Saving to Dynamo...", state);
                    const resp = await saveDynamo(state);
                    setState((prevState) => ({...prevState, ...resp}));
                }
            }
        }
        runEffect();
    }, [state.pageNumber]);

    const prevPage = (e) => {
        e.preventDefault();

        setState((prevState) => {
            const newIndex = Math.max(prevState.currentPageIndex - 1, 0);
            const currentPage = (prevState.pages && prevState.pages[newIndex]) || ''
        
            return {
              ...prevState,
              pageNumber: prevState.pageNumber - 1,
              currentPageIndex: newIndex,
              currentPage: currentPage
            };
          });
    };

    const nextPage = async (e) => {
      e.preventDefault();

      let fetchedState;
      if (state.pageNumber === 1) {
        // console.log('first page!! Initial state: ', state);
        fetchedState = await getDynamo(state);
        // console.log('first page!! fetched state: ', fetchedState);
      }

      if (fetchedState) {
        if (fetchedState.pageNumber === 1) {
          const newIndex = fetchedState.currentPageIndex + 1;
          const currentPage = (fetchedState.pages && fetchedState.pages[newIndex]) || '';

          await setState(prevState => ({
            ...prevState,
            ...fetchedState,
            featureFlags: prevState.featureFlags, // ✅ Keep original featureFlags
            pageNumber: fetchedState.pageNumber + 1,
            currentPageIndex: newIndex,
            currentPage: currentPage,
          }));

        } else {
          await setState(prevState => ({
            ...prevState,
            ...fetchedState,
            featureFlags: prevState.featureFlags, // ✅ Preserve featureFlags even here
          }));
        }

      } else {
        // console.log('SETTING PAGE NUMBER', state.pageNumber + 1);

        await setState((prevState) => {
          const newIndex = prevState.currentPageIndex + 1;
          const currentPage = (prevState.pages && prevState.pages[newIndex]) || '';

          return {
            ...prevState,
            pageNumber: prevState.pageNumber + 1,
            currentPageIndex: newIndex,
            currentPage: currentPage,
          };
        });
      }
    };

    return { 
        state, setState, prevPage, nextPage
    };
}

export const handleComponentChange = setState => e => {
    const { name, value } = e.target;

    if (name === 'rego') {
        setState((prevState) => ({ ...prevState, [name]: value.toUpperCase() }));
    }
    else if (name === 'carLocPostcode') {
        // Remove any non-numeric characters and ensure max length is 4
        const sanitizedValue = value.replace(/\D/g, '').slice(0, 4); 

        setState((prevState) => ({ ...prevState, [name]: sanitizedValue }));
    }
    else if (name === 'phone') {
        let temp = validatePhoneNumber(value);
        setState((prevState) => ({ ...prevState, [name]: temp }));
    }
    else {
        setState((prevState) => ({ ...prevState, [name]: value }));
    }
};

export const handlePatchRequest = async () => {
    return true
}
